export default __webpack_public_path__ + "static/media/Sreeram1.0f76f893.jpg";